import { Avatar } from "@mui/material";

import { useSelector } from "react-redux";
import PhotoUploadCrop from "components/File/PhotoUploadCrop";

function getInitials(firstName, lastName) {
    return `${firstName?.charAt(0) || ""}${lastName?.charAt(0) || ""}`;
}

export default function UserAvatar(props) {
    const profile = useSelector((state) => state.user.profile);

    const initials = getInitials(profile?.firstName, profile?.lastName);
    const photo = profile?.photoFileName;
    if (photo)
        return (
            <PhotoUploadCrop
                value={photo}
                sourceImage={photo}
                // label="Profile Photo"
                size={34}
                readOnly
            />
        );

    return <Avatar>{initials}</Avatar>;
}
